<template>
  <div>
    <nav-bar class="home-nav">
      <div slot="left" @click="onClickLeft">返回</div>
      <div slot="center">更多</div>
    </nav-bar>

    <van-grid v-if="stuShow" style="margin: 10px">
      <van-grid-item to="/PhysicalTestQuery" icon="https://img.coolcr.cn/2021/01/24/44b60058b3faa.png" text="体测查询"/>
      <van-grid-item to="TestBookingManage" icon="https://img.coolcr.cn/2021/01/24/1855bff093be2.png"
                     text="体测预约"/>
      <van-grid-item to="NoTestApply" icon="https://img.coolcr.cn/2021/01/24/b3dca31b1969c.png"
                     text="免测申请"/>
      <van-grid-item @click="vision" icon="https://img.coolcr.cn/2021/01/24/b3dca31b1969c.png" text="视力填报"/>

      <van-grid-item to="music" icon="http://icon.hhstu.club/%E9%9F%B3%E4%B9%90.png"
                     text="音乐"/>
    </van-grid>
    <van-grid v-if="teaShow" style="margin: 10px">
      <van-grid-item to="music" icon="http://icon.hhstu.club/%E9%9F%B3%E4%B9%90.png"
                     text="音乐"/>
    </van-grid>
    <van-grid v-if="adminShow" style="margin: 10px">
      <!--      <van-grid-item to="music" icon="http://icon.hhstu.club/%E9%9F%B3%E4%B9%90.png"-->
      <!--                     text="音乐"/>-->
      <van-grid-item to="TestBookingManage" icon="http://icon.hhstu.club/ticeyuyue.png"
                     text="体测预约"/>
      <van-grid-item to="NoTestApplyList" icon="http://icon.hhstu.club/miance.png"
                     text="免测申请列表"/>
      <van-grid-item to="PhysicalTestList" icon="http://icon.hhstu.club/chaxun.png"
                     text="体测成绩列表"/>
      <van-grid-item to="SportsMeet" icon="http://icon.hhstu.club/%E6%B4%BB%E5%8A%A8%20%281%29.png"
                     text="运动会管理"/>
      <van-grid-item to="SportsMeetSerial" icon="http://icon.hhstu.club/%E6%B4%BB%E5%8A%A8%20%281%29.png"
                     text="运动会序号管理"/>
      <van-grid-item to="CampusActivities" icon="http://icon.hhstu.club/campus_run.png"
                     text="校园体育活动"/>
    </van-grid>

    <van-action-sheet position="top" v-model="vishonShow" :title="'视力填报 当前:左('+leftv+') 右('+rightv+')'">

      <van-form @submit="onVisionSubmit">
        <van-field
          readonly
          clickable
          name="leftv"
          :value="leftv"
          label="左眼"
          placeholder="点击选择左眼视力"
          @click="showLeftPicker = true"
        />
        <van-popup v-model="showLeftPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="leftcolumns"
            @confirm="onLeftConfirm"
            @cancel="showLeftPicker = false"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          name="rightv"
          :value="rightv"
          label="右眼"
          placeholder="点击选择右眼视力"
          @click="showRightPicker = true"
        />
        <van-popup v-model="showRightPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="rightcolumns"
            @confirm="onRightConfirm"
            @cancel="showRightPicker = false"
          />
        </van-popup>

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>

    </van-action-sheet>

  </div>
</template>

<script>
import {StuModifyVision} from "@/network/student";
import NavBar from "components/common/navbar/NavBar";
import Vue from 'vue';
import {
  Toast, Grid, GridItem, Field, Form, ActionSheet, Button, Picker, Popup
} from 'vant';


Vue.use(Toast);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Field);
Vue.use(Form);
Vue.use(ActionSheet);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);


export default {
  name: "More",
  components: {
    NavBar
  },
  data() {
    return {
      //action sheet
      vishonShow: false,

      //picker
      showLeftPicker: false,
      leftv: "",
      leftcolumns: [],
      showRightPicker: false,
      rightv: "",
      rightcolumns: [],
    }
  },
  activated() {
    this.leftv = this.$cookies.get("info").leftv;
    this.rightv = this.$cookies.get("info").rightv;
    this.leftcolumns = [];
    this.rightcolumns = [];
    for (let i = 0; i < 10; i++) {
      this.leftcolumns.push(4 + '.' + i);
      this.rightcolumns.push(4 + '.' + i);
    }
    for (let i = 0; i < 2; i++) {
      this.leftcolumns.push(5 + '.' + i);
      this.rightcolumns.push(5 + '.' + i);
    }
  },
  computed: {
    stuShow() {
      return this.$cookies.get("user") === "student"
    },
    teaShow() {
      return this.$cookies.get("user") === "teacher"
    },
    adminShow() {
      return this.$cookies.get("user") === "admin"
    }
  },
  methods: {
    onClickLeft() {
      this.$router.replace("/home");
    },
    vision() {
      this.vishonShow = true;
    },
    onVisionSubmit(value) {
      StuModifyVision(value.leftv, value.rightv).then(res => {
        this.vishonShow = false;
        if (res) {
          let info = this.$cookies.get("info");
          info.leftv = value.leftv;
          info.rightv = value.rightv;
          this.$cookies.set("info", info, '6m');
          Toast("填报成功");
        } else {
          Toast("填报失败");
        }
      })
    },
    onLeftConfirm(value) {
      this.leftv = value;
      this.showLeftPicker = false;
    },
    onRightConfirm(value) {
      this.rightv = value;
      this.showRightPicker = false;
    },
  }
}
</script>

<style scoped>

</style>
